import api from "./api";

// Resgate Comercial (Dr. Rostand). Tudo passa pelo `api` (JWT + companyId
// do backend) — isolado por tenant. Substitui o Firebase aberto do painel.

export const listRescueLeads = async () => {
  const { data } = await api.get("/rescue-leads");
  return data;
};

export const getRescueStats = async () => {
  const { data } = await api.get("/rescue-leads/stats");
  return data;
};

export const createRescueLead = async (payload) => {
  const { data } = await api.post("/rescue-leads", payload);
  return data;
};

export const updateRescueLead = async (id, payload) => {
  const { data } = await api.put(`/rescue-leads/${id}`, payload);
  return data;
};

export const moveRescueLead = async (id, stage, position) => {
  const { data } = await api.put(`/rescue-leads/${id}/move`, {
    stage,
    position
  });
  return data;
};

export const deleteRescueLead = async (id) => {
  const { data } = await api.delete(`/rescue-leads/${id}`);
  return data;
};

// Fase 3 v1.5 — Timeline de atividade do lead.
export const listRescueLeadActivities = async (id) => {
  const { data } = await api.get(`/rescue-leads/${id}/activities`);
  return data;
};

// S45 A14 — Lista de procedimentos ativos do tenant (clinic_services)
// pra alimentar o Autocomplete. Aberto pra qualquer profile.
export const listProcedureOptions = async () => {
  const { data } = await api.get(`/rescue-leads/procedures-options`);
  return Array.isArray(data) ? data : [];
};
